import { PromptTypeEnum } from "../../base/decorator/error/PromptType.enum";
import { CommonTool } from "../../common/tool/common-tool";

/**
 * @description 用户权限处理的Manager
 * @deprecated
 * 主要功能:
 * 1.检查当前是否是有效的实名用户
 */
export class UserManager {

    public static readonly $inject: string[] = ["pageContext", "$q", "runtimeContext", "$window"];
    
    public readonly rootPath: string;

    constructor(public pageContext: qpmn.main.IPageContext, public $q: angular.IQService, public runtimeContext: qpmn.main.IRuntimeContext, private $window: angular.IWindowService) {
        this.rootPath = this.pageContext.rootPath;
    }

    private defaultLoginQuestionConfig = {
        // 是否反向显示confirm和取消按钮
        reverseButtons: true,
        // 是否显示取消按钮
        showCancelButton: false,
        // 取消按钮的自定义class类
        cancelButtonClass: 'alert-login-cancel',
        // 确认按钮的自定义class类
        confirmButtonClass: 'alert-login-confirm',
        // 为按钮添加默认的swal2样式
        buttonsStyling: true,
        // 是否允许点击对话框外部来关闭对话框
        allowOutsideClick: false,
        // 是否允许按下Esc键来关闭对话框
        allowEscapeKey: false,
        title: ENV_IS_CN ? "权限无效" : "Permission invalid",
        content: ENV_IS_CN ? "去登录" : "Go to login",
        cancelButtonText: ENV_IS_CN ? '取消' : "CANCEL",
        confirmButtonText: ENV_IS_CN ? "确定" : "OK",
    }

    /**
     * @description 判断当前用户是否为合法的实名用户(已登录且未过期)
     * @returns 
     */
    public isAuthorized() {
        return !this.runtimeContext.isAnonymous() && !this.runtimeContext.isExpire();
    }

    /**
     * @description 权限过期提示
     * 用户确认后跳转至登录页
     * 默认采用question类型
     */
    public invalidPrompt(promptConfig?: qpmn.base.decorator.error.CatchErrorConfig) {
        let title = promptConfig && promptConfig.title ? promptConfig.title : "Go to login?";
        let content = "You are not currently logged in or the permission is invalid";
        let extendCfg = promptConfig && promptConfig.extendCfg ? promptConfig.extendCfg : this.defaultLoginQuestionConfig;
        let PROMPTTYPE = promptConfig && promptConfig.type ? promptConfig.type : PromptTypeEnum.QUESTION;
        // 只有当询问时才需要有取消按钮
        if (PROMPTTYPE == PromptTypeEnum.QUESTION) {
            extendCfg.showCancelButton = true;
        }
        window.qpAlertPrompt[PROMPTTYPE](title, content, {
            fn: () => {
                // 记录当前页面地址并跳转至登录页
                this.goToLogin();
            }
        }, {}, extendCfg);
    }


    public goToLogin() {
        this.$window.location.href = this.rootPath + "partner/login/" + "?" + encodeURIComponent(location.href);
    }

}